//大屏弹框
let dialogOpening = false

const openDialog = function (options, style = {}, destroyed) {
  let { height } = options
  if (!height) return false
  let defaultConent = "DsfViewPart";
  if (!dialogOpening) {
    options = options || {};
    dialogOpening = true;
    let openerVm = options.openerVm ? options.openerVm : this._isVue ? this : null;
    let comp = null;
    if (options) {
      if (!options.template) {
        if (options.params && options.params.path && !options.content) {
          options.content = defaultConent;
        }
        if (options.content == defaultConent) {
          options.params.showModel = "full";
          options.params.isOpenDialog = true;
          options.params.forceUpdate = false;
        }
      }
    }

    let app = window.document.querySelector("#app");
    let docHeight = window.innerHeight
    let titleHeight = parseInt(style.titleHeight) || 40
    let height = parseInt(options.height)

    let dialogContentHeight = (height - titleHeight) + 'px'

    let marginTop = `${-titleHeight + (docHeight - height) / 2}px`
    let router = this.$router || app?.__vue__?.$root?.$options?.router || options.router;
    let store = this.$store || app?.__vue__?.$root?.$options?.store || options.store;
    let i18n = this.$i18n || app?.__vue__?.$root?.$options?.i18n || options.i18n;
    let service = openerVm ? openerVm.$service : {};
    let appRoot = router ? router.apps[0] : app.__vue__.$root;
    let _self = window;
    let component = null;
    let elConfig = {
      router,
      store: store,
      i18n: i18n,
      components: undefined,
      provide() {
        return {
          $serviceInfo: service
        };
      },
      beforeCreate() {
        if (openerVm && openerVm._routerRoot) {
          this._routerRoot = openerVm._routerRoot;
        } else {
          this._routerRoot = this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
        }
      },
      data: function () {
        return {
          styleConfig: style,
          index: dsf.uuid(),
          dialogVisible: false,
          clearDialog: false,
          clearConent: false,
          //标题
          title: dsf.isDef(options.title) ? options.title : "",
          //组件名称
          content: options.content,
          width: options.width || "50%",
          height: dialogContentHeight || "auto",
          destroyOnClose: true,
          params: options.params || {},
          overflow: options.overflow || "auto",
          btns: [],
          events: options.event,
          fullscreen: options.fullscreen,
          openerVm: openerVm,
          dialogArgs: options.dialogArgs || null,
          top: marginTop,
          yes: options.yes || dsf.noop,
          showClose: dsf.isDef(options.showClose) ? options.showClose : true,
          modal: dsf.isDef(options.modal) ? options.modal : false,
          center: dsf.isDef(options.center) ? options.center : false,
          closed: options.closed || dsf.noop,
          conentBorder: options.conentBorder || null,
          customClass: options.customClass || "",
          draggable: true,
          /**
           * 弹窗自动关闭配置，可选值 close自动关闭，disabled:禁止路由切换，ignore：忽略除调用关闭方法或者手动关闭以外任何变化
           */
          autoCloseConfig: dsf.mix(true, {}, options.autoCloseConfig || {}, {
            //路由变化时配置
            routerChange: "close"
          })
        };
      },
      computed: {
        options() {
          return options;
        },
      },
      created() {
        if (this.height.endsWith("%")) {
          this.height = this.height.replace("%", "vh");
        }
      },
      mounted() {
        if (options.content == defaultConent || this.template) {
          this.$nextTick(() => {
            options.dialogLoaded && options.dialogLoaded(options.content == defaultConent ? this.$refs.content : null);
          });
        }
      },
      destroyed() {
        for (let k in this._data) {
          this._data[k] = null;
        }
        dsf.array.remove(appRoot?.$dialogAll || [], this);
        options = null;
        openerVm = null;
        app = null;
        router = null;
        store = null;
        i18n = null;
        _self = null;
        service = null;
        this._routerRoot = null;
        destroyed && destroyed();
      },
      methods: {
        async dialogSure(result) {
          await options.yes?.(this.$refs.content);
          this.close();
        },
        onDialogMounted() {
          this.dialogVisible = true;
        },
        onOpened() {
          let fn = options.onOpened;
          dsf.isFunction(fn) && fn();
          dsf.resizeComponent(this.$refs.instance);
        },
        close() {
          this.$refs?.instance?.close?.();
        },
        onClosed() {
          if (this.closed) {
            this.closed(this.$refs.content);
            options.onClosed?.();
          }
        },
        cancel() {
          let _this = this;
          if (component) {
            component = null;
          }
          this.$nextTick().then(() => {
            this.clearConent = true;
            let closeId = window.setTimeout(() => {
              closeId && window.clearTimeout(closeId);
              _this.$destroy();
              this.$nextTick().then(() => {
                if (_this._vnode) {
                  _this._vnode = null;
                }
                if (_this?.$el) {
                  _this.$el.__vue__ = null;
                }
                _this.$el = null;
                _this = null;
                //
                //处理一些el-dialog奇奇怪怪的内存泄漏问题
                try {
                  //chrome的bug，当一个被聚焦过的文本框被移除，会导致该文本框相关内存无法销毁，
                  //因为文本框节点又有parentNode引用父节点，从而导致一连串dom对象无法被释放
                  dsf.momoryRelease();
                } catch (ex) {
                  //todo
                }
              });
            }, 1000);
          });
        },
        contentReady() {
        },
      },
      template: `
      <DsfDataViewDialog
        v-if="!clearDialog"
        :key="index"
        ref="instance"
        class="ds-dialog-show-animation"
        :no-title="true"
        :conent-border="conentBorder"
        :styleConfig="styleConfig"
        :title="title" 
        :top="top" 
        :index="index" 
        :options="options"
        :visible.sync="dialogVisible"
        :fullscreen="fullscreen" 
        :width="width"
        :height="height"
        :close-on-click-modal="false" 
        :append-to-body="true"
        :show-close="showClose" 
        :close-on-press-escape="false" 
        :dialog-args="dialogArgs"
        :modal="modal" 
        :center="center" 
        :opener-vm="openerVm" 
        :allow-draggable="draggable"
        @opened="onOpened"
        @close="onClosed"
        @closed="cancel"
        @hook:mounted="onDialogMounted">
        <div class="ds-dialog-content" ref="contentWrapper" :style="{'position':'relative','height':'100%'}">
          <template>
          ${options.template
          ? options.template
          : `<component 
              v-if="!clearConent"
              :key="'dialog-content-'+index"
              :is="content" 
              v-bind.sync="params" 
              ref="content" 
              v-on="events" 
              ${options.content == "DsfViewPart" ? '@ready="contentReady"' : ""}
              @dialog-yes="dialogSure">
            </component>`
        }
          </template>
        </div>
      </DsfDataViewDialog>`
    };
    if (comp) {
      elConfig.components = {
        [options.content]: comp
      };
    }
    if (options.btns) {
      _.each(options.btns, (btn) => {
        if (btn.handler) {
          btn.handler = btn.handler.bind(_self);
        }
      });
    }
    let top = dsf.getTopWindow();
    const Dialog = Vue.extend(elConfig);
    component = new Dialog({ el: document.createElement("div") });
    if (dsf.isUnDef(options.isTopOpen)) {
      options.isTopOpen === dsf.config.component.topOpenDialog || false;
    }
    if (options.isTopOpen === true) {
      if (top != _self) {
        let el = component.$el;
        let modal = el.previousElementSibling;
        top.document.body.appendChild(modal);
        top.document.body.appendChild(el);
        // component.dialogVisible=true;
      }
    }
    if (appRoot) {
      if (dsf.isUnDef(appRoot.$dialogAll)) {
        appRoot.$dialogAll = [];
      }
      appRoot.$dialogAll.push(component);
    }
    dialogOpening = false;
    return component;
  }
}
const layer = {
  openDialog
}
export default layer